import { Component, Input, OnInit, ViewChild, viewChild } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { ProjectService } from '../../../../services/project.service';
import { CommonModule } from '@angular/common';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../services/auth.service';
import { authUser } from '../../../../interfaces/auth/auth.model';
import { DirectionService } from '../../../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';
import { SocketService } from '../../../../services/socket.service';
import { NotificationService } from '../../../../services/notification.service';
import { IProject, NotificationTypesEnum } from '../../../../interfaces';

@Component({
  selector: 'app-plan',
  standalone: true,
  imports: [
    ButtonModule,
    FormsModule,
    IconFieldModule,
    InputTextModule,
    InputIconModule,
    TableModule,
    CommonModule,
    InputTextareaModule,
    TranslateModule
  ],
  templateUrl: './plan.component.html',
  styleUrl: './plan.component.scss'
})
export class PlanComponent implements OnInit {
  @ViewChild('reasonsForm') reasonsForm!: FormGroup;
  @Input() strategyId!: number;
  @Input() projectId!: number;
  @Input() project!: IProject;
  isModalVisible = false;
  reasonsText = ''
  isSubmitted = false;
  managementChanges = [] as any[];
  user!: authUser;
  is_on_hold = false;
  dir!: 'rtl' | 'ltr';
  locale!: "ar" | "en";
  constructor(
    private projectService: ProjectService,
    private toastr: ToastrService,
    private authService: AuthService,
    private notificationService: NotificationService,
    private directionService: DirectionService,
  ) {
  }
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      this.locale = dir == "rtl" ? "ar" : "en";
    })
    this.projectService.ListManagementChanges(this.strategyId, this.projectId).subscribe((response: any) => {
      this.managementChanges = response['data']['changes']
      this.is_on_hold = this.managementChanges[this.managementChanges.length - 1]?.is_on_hold || false

      this.authService.authBufferSub$.subscribe((user) => {
        this.user = user as authUser;
      })
    })
  }
  // searchTerm = ""

  showModal() {
    this.isModalVisible = true;
  }
  closeModal() {
    this.isModalVisible = false;
  }

  submitChange() {
    this.isSubmitted = true;

    if (this.reasonsForm.valid) {
      this.projectService.createManagementChanges(this.strategyId, this.projectId, {
        "is_on_hold": !this.is_on_hold,
        "reasons": this.reasonsText
      }).subscribe((response: any) => {
        this.managementChanges.push({
          "is_on_hold": !this.is_on_hold,
          "created_at": new Date(),
          "reasons": this.reasonsText,
          "in_charge_name": this.user.name
        })
        this.notificationService.pushProjectExecutionNotification(
          +this.strategyId,
          +this.projectId,
          this.reasonsText,
          this.is_on_hold ? NotificationTypesEnum.project_execution_resume : NotificationTypesEnum.project_execution_stop,
          this.locale
        );
        this.reasonsText = ''
        this.is_on_hold = !this.is_on_hold;
        this.isModalVisible = false;
        this.toastr.success(response['data']['message']);
      })
    }
    else {
      this.toastr.error(this.dir == 'rtl' ? 'اكتب الاسباب' : 'Please enter the reasons');
    }
  }

}
